var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilestonePath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 398,
    height: 306,
    viewBox: "0 0 398 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 24C242 42.048 374 106.346 374 305.999",
    strokeWidth: 48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestonePath);
export default __webpack_public_path__ + "static/media/milestonePath.0ca3219a1c92c86e5acc31bbba8890f4.svg";
export { ForwardRef as ReactComponent };